import React from "react";
import { SportCodes } from "@prestosports/prestostats-core/Common";
import { useSeasonContext } from "../../../state/season/context";
import FootballGameStatsContainer from "../../football/containers/GameStatsContainer";
import TennisGameStatsContainer from "../../tennis/containers/GameStatsContainer";
import FootballGameStartContainer from "../../football/containers/GameStartContainer";
import TennisGameStartContainer from "../../tennis/containers/GameStartContainer";
import FootballGameContainer from "../../football/containers/GameContainer";
import TennisGameContainer from "../../tennis/containers/GameContainer";
import FootballGameFinalizeContainer from "../../football/containers/GameFinalizeContainer";
import TennisGameFinalizeContainer from "../../tennis/containers/GameFinalizeContainer";
import FootballGameInfoContainer from "../../football/containers/GameInfoContainer";
import TennisGameInfoContainer from "../../tennis/containers/GameInfoContainer";
import FootballTeamInfoContainer from "../../football/containers/TeamInfoContainer";
import TennisTeamInfoContainer from "../../tennis/containers/TeamInfoContainer";
import FootballSeasonSettings from "../../football/components/SeasonSettings";
import TennisSeasonSettings from "../../tennis/components/SeasonSettings";
import FootballAddPlayerContainer from "../../football/containers/AddPlayerContainer";
import TennisAddPlayerContainer from "../../tennis/containers/AddPlayerContainer";
import AppSections from "../../../routes/app-sections";
import Authorize from "../../football/components/Authorize";
import GameDataConflictNotification from "../../game/components/GameDataConflictNotification";
import TeamImportContainer from "./TeamImportContainer";
import DebugPanel from "../components/debug/DebugPanel";
import Stream from "../components/Stream";

const SportMappings = {
	[SportCodes.Football]: {
		[AppSections.Game.id]: <FootballGameContainer />,
		[AppSections.GameStats.id]: <FootballGameStatsContainer />,
		[AppSections.GameConfig.id]: <FootballGameStartContainer />,
		[AppSections.GameFinalize.id]: <FootballGameFinalizeContainer />,
		[AppSections.GameInfo.id]: <FootballGameInfoContainer />,
		[AppSections.TeamInfo.id]: <FootballTeamInfoContainer />,
		[AppSections.TeamImport.id]: <TeamImportContainer />,
		[AppSections.SeasonSettings.id]: <FootballSeasonSettings />,
		[AppSections.AddPlayer.id]: <FootballAddPlayerContainer />,
		[AppSections.Stream.id]: <Stream popout />
	},
	[SportCodes.FlagFootball]: {
		[AppSections.Game.id]: <FootballGameContainer />,
		[AppSections.GameStats.id]: <FootballGameStatsContainer />,
		[AppSections.GameConfig.id]: <FootballGameStartContainer />,
		[AppSections.GameFinalize.id]: <FootballGameFinalizeContainer />,
		[AppSections.GameInfo.id]: <FootballGameInfoContainer />,
		[AppSections.TeamInfo.id]: <FootballTeamInfoContainer />,
		[AppSections.TeamImport.id]: <TeamImportContainer />,
		[AppSections.SeasonSettings.id]: <FootballSeasonSettings />,
		[AppSections.AddPlayer.id]: <FootballAddPlayerContainer />,
		[AppSections.Stream.id]: <Stream popout />
	},
	[SportCodes.Tennis]: {
		[AppSections.Game.id]: <TennisGameContainer />,
		[AppSections.GameStats.id]: <TennisGameStatsContainer />,
		[AppSections.GameConfig.id]: <TennisGameStartContainer />,
		[AppSections.GameFinalize.id]: <TennisGameFinalizeContainer />,
		[AppSections.GameInfo.id]: <TennisGameInfoContainer />,
		[AppSections.TeamInfo.id]: <TennisTeamInfoContainer />,
		[AppSections.TeamImport.id]: <TeamImportContainer />,
		[AppSections.SeasonSettings.id]: <TennisSeasonSettings />,
		[AppSections.AddPlayer.id]: <TennisAddPlayerContainer />,
		[AppSections.Stream.id]: <Stream popout />
	},
	[SportCodes.WomenTennis]: {
		[AppSections.Game.id]: <TennisGameContainer />,
		[AppSections.GameStats.id]: <TennisGameStatsContainer />,
		[AppSections.GameConfig.id]: <TennisGameStartContainer />,
		[AppSections.GameFinalize.id]: <TennisGameFinalizeContainer />,
		[AppSections.GameInfo.id]: <TennisGameInfoContainer />,
		[AppSections.TeamInfo.id]: <TennisTeamInfoContainer />,
		[AppSections.TeamImport.id]: <TeamImportContainer />,
		[AppSections.SeasonSettings.id]: <TennisSeasonSettings />,
		[AppSections.AddPlayer.id]: <TennisAddPlayerContainer />,
		[AppSections.Stream.id]: <Stream popout />
	}
};

const AppSectionContainer = ({ appSection }) => {
	const { state: seasonState } = useSeasonContext();

	const currentSeason = seasonState.currentSeason();
	const { sport } = currentSeason || {};
	const { sportId } = sport || {};

	const knownSport = SportMappings[sportId];
	const knownSection = knownSport && (
		<Authorize gameAccess={appSection.gameAccess}>
			{SportMappings[sportId][appSection.id]}
		</Authorize>
	);

	return (
		currentSeason && (
			<>
				{!knownSport && <>The app does not support the season sport</>}
				{knownSport && !knownSection && <>Unknown section</>}
				{knownSport && knownSection}
				<GameDataConflictNotification />
				<DebugPanel />
			</>
		)
	);
};

// AppSectionContainer.whyDidYouRender = true;

export default AppSectionContainer;
